export default __webpack_public_path__ + "static/community_321-702ecad0622752d854f0fbc9871e31ab.jpg";